import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import VeeValidate, { Validator } from 'vee-validate'
import nl from 'vee-validate/dist/locale/nl'
import VueScrollTo from 'vue-scrollto'
import firebase from 'firebase/app'
import 'firebase/auth'

import Index from '@/components/Index'
import DefaultLayout from '@/components/DefaultLayout'
import Login from '@/components/Login'
import Contact from '@/components/Contact'
import TermsOfService from '@/components/TermsOfService'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Profile from '@/components/Profile'
import Access from '@/components/Access'
import Error404 from '@/components/Error404'

Vue.use(Router)
Vue.use(Meta)
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})
Vue.use(VueScrollTo)

Validator.localize('nl', nl)

const router = new Router({
  mode: 'history',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/site',
      component: DefaultLayout,
      children: [
        {
          path: '404',
          name: '404',
          component: Error404
        },
        {
          path: 'terms-of-service',
          name: 'terms-of-service',
          component: TermsOfService
        },
        {
          path: 'privacy-policy',
          name: 'privacy-policy',
          component: PrivacyPolicy
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        },
        {
          path: 'login',
          name: 'login',
          component: Login
        }
      ]
    },
    {
      path: '/user',
      component: DefaultLayout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        {
          path: 'access',
          name: 'access',
          component: Access
        }
      ]
    },
    {
      path: '*',
      redirect: { name: '404' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const firebaseUser = firebase.auth().currentUser

  if (requiresAuth && !firebaseUser) {
    next({ name: 'login' })
  } else if (to.name === 'index' && firebaseUser) {
    next({ name: 'profile' })
  } else if (to.name === 'login' && firebaseUser) {
    next({ name: 'profile' })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js